let defaultErrorLog = {
    id: null,
    ip: '',
    date: '',
    message: '',
    users: null,
};

export default defaultErrorLog;

